import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  exist: false,
  text: null,
  horizontalAlignment: "center",
  verticalAlignment: "top",
};

export const chartTitleSlice = createSlice({
  name: "chartTitle",
  initialState,
  reducers: {
    updateChartTitleExist: (state, action) => {
      return {
        ...state,
        exist: !state.exist,
      };
    },
    updateChartTitle: (state, action) => {
      return {
        ...state,
        text: action.payload,
      };
    },
    updateChartTitleAlignment: (state, action) => {
      return {
        ...state,
        horizontalAlignment: action.payload.horizontalAlignment,
        verticalAlignment: action.payload.verticalAlignment,
      };
    },
  },
});

export const {
  updateChartTitleExist,
  updateChartTitle,
  updateChartTitleAlignment,
} = chartTitleSlice.actions;

export default chartTitleSlice.reducer;
